import { render, staticRenderFns } from "./cpzljc.vue?vue&type=template&id=2e99f2d2&scoped=true"
import script from "./cpzljc.vue?vue&type=script&lang=js"
export * from "./cpzljc.vue?vue&type=script&lang=js"
import style0 from "./cpzljc.vue?vue&type=style&index=0&id=2e99f2d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e99f2d2",
  null
  
)

export default component.exports